import { useEffect, useRef, useCallback } from 'react';
import useStore from '../../../store';
import { recalculateLayout } from '../utils/layoutManager';

// Хук для управления расчетом лейаута и настройкой канвасов
function useLayoutManager(boardCanvasRef, trayCanvasRef) {
  
    const updateLayout = useStore((state) => state.updateLayout); // Триггер из стора
    const imageDimensions = useStore((state) => state.ref.puzzle.state.imageDimensions); // <<< Подписка на размеры изображения
    const store = useStore.getState(); // Доступ к ref
    const { ref } = store;
    const { puzzle } = ref;
    const { config } = puzzle;

    const debounceTimeoutRef = useRef(null);

    // Мемоизированная функция пересчета (чтобы не создавать новую на каждый рендер)
    const triggerRecalculation = (options) => {

      recalculateLayout(boardCanvasRef);
      ref.puzzle.methods.redraw({ lite: true });


    }; 

    // Обработчик ресайза окна с debounce
    const handleResize = () => {

      recalculateLayout(boardCanvasRef);

      if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(() => {
          console.log("Window resized, recalculating layout...");
          triggerRecalculation();
          debounceTimeoutRef.current = null;
      }, 300); // Задержка debounce
    }

    // Основной эффект для запуска пересчета
    useEffect(() => {

        // Устанавливаем слушатель ресайза
        window.addEventListener('resize', triggerRecalculation);
        window.addEventListener('orientationchange', triggerRecalculation); // Добавим и смену ориентации

        // Очистка при размонтировании
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
            window.removeEventListener('resize', triggerRecalculation);
            window.removeEventListener('orientationchange', triggerRecalculation);
            console.log("Layout manager cleanup.");
        };
    }, []); 

    
    useEffect(() => {
        if (imageDimensions?.width > 0 && imageDimensions?.height > 0) {
            triggerRecalculation();
        }
    }, [imageDimensions]);

    useEffect(() => {
      triggerRecalculation();
    }, [config.user.trayHeight, config.user.trayGapFactor, puzzle.boardTransform.scale]);
}

export default useLayoutManager;
